import { DefaultTheme } from 'styled-components';

export type ColorsType = typeof colors;
export type TypographyType = typeof typography;

const colors = {
    // General
    whiteColor: '#FFFFFF',
    blackColor: '#000000',
    grayColor: '#AAAAAA',

    // Point
    pointBlue: '#1B6EB5',
    positiveBlue: '#0078FF',
    activeGreen: '#2ECC35',
    activeOrange: '#FF5700',
    activePink: '#FF8080',
    graphPurple: '#8979FF',
    graphBlue: '#70C4FD',
    positiveGreen: '#34C759',
    activeRed: '#FF2D55',
    pointPink: '#DD8EA4',
    pointGreen: '#3D5A5B',
    pointRed: '#E71D36',
    warningRed: '#D23838',

    // activeRed: '#FF3B30',
    textRed: '#E63333',
    badgeBgOrange: '#FFB188',
    activeBlue: '#70C4FD',
    activeSkyBlue: '#6679FE',
    badgeBgBlue: '#CDE4FF',
    // warningRed: '#FF6464',
    // activeGreen: '#48D262',
    // positiveGreen: '#34C759',
    badgeTextGreen: '#4BBB46',
    badgeBgGreen: '#D7EBD8',
    badgeTextPurple: '#6679FE',
    badgeBgPurple: '#C5CCFF',
    badgeTextYellow: '#9F8600',
    badgeBgYellow: '#FFED8D',
    // graphPurple: '#8979FF',
    graphGreen: '#2ECC35',
    graphRed: '#DA4055',

    // Icon
    grayIconColor: '#919191',
    closeIcon: '#CACBD4',

    // Font
    grayFontColor: '#7B7B80',
    lightGrayFontColor: '#B3B3B3',
    sidebarGrayFontColor: '#CFCFCF',
    ultraLightGrayFontColor: '#D1D1D1',
    deepGrayFontColor: '#6E6E6E',
    progressBarColor: '#D9D9D9',
    subTitleColor: '#949494',

    // Border
    lightGrayBorder: '#E5E5E5',
    ultraLightGrayBorder: '#F3F3F3',
    brightGrayBorderColor: '#E8E8E8',

    // Background
    lightGrayHoverColor: '#F9F9F9'
};
const typography = {
    largeTitle: {
        // Large Title
        fontSize: '28px',
        lineHeight: '36px'
    },
    mediumTitle: {
        // Title 1 (medium title)
        fontSize: '24px',
        lineHeight: '32px'
    },
    headline1: {
        // Headline 1
        fontSize: '20px',
        lineHeight: '28px'
    },
    headline2: {
        // Headline 2
        fontSize: '16px',
        lineHeight: '24px'
    },
    bodyDesktop: {
        // Body Desktop
        fontSize: '18px',
        lineHeight: '26px'
    },
    bodyMobile: {
        // Body Mobile
        fontSize: '14px',
        lineHeight: '22px'
    },
    caption: {
        // Caption
        fontSize: '12px',
        lineHeight: '18px'
    }
};

const theme: DefaultTheme & {
    colors: ColorsType;
    typography: TypographyType;
} = {
    colors,
    typography
};

export default theme;
